// Resource constants and mock data

export const validationReRunMockDataOld: any = {
  validation_parameters: {
    resource_data: {
      resource_id: 913,
      linked_service_id: 27,
      linked_service_code: "localFile1",
      connection_key: 28,
      resource_path: "E:\\Data_Files\\SampleFiles\\Research_query_files",
      file_name: "GWP_Position_202212124_Change_int.xlsx",
      column_delimiter: "|",
      aggregation_base_resource_data: null,
      additional_base_resource_data: [
        {
          resource_id: 1408,
          linked_service_id: 27,
          linked_service_code: "localFile1",
          connection_key: 28,
          resource_path: "E:\\Data_Files\\SampleFiles\\Research_query_files",
          file_name: "AdditionalResource_3.xlsx",
          column_delimiter: ",",
          file_pre_processing: {
            file_format: "xlsx",
            schema_definition: "string",
            field_delimiter: "|",
            custom_attributes: {
              type: "string",
              store_name: "string",
              store_label: "string",
            },
            has_footer: false,
            footer_lines: 0,
            has_header: true,
            header_lines: 0,
            skip_rows: 0,
            has_multiple_sheets: false,
            skip_blanks: true,
            compression: null,
            compression_codec: null,
            line_terminator: "\n",
            has_comments: "false",
            comments_marker: "#",
            encoding: "utf-8",
            bad_lines: "skip",
          },
        },
      ],
      file_pre_processing: {
        file_format: "xlsx",
        schema_definition: "string",
        field_delimiter: "|",
        custom_attributes: {
          type: "string",
          store_name: "string",
          store_label: "string",
        },
        has_footer: false,
        footer_lines: 0,
        has_header: true,
        header_lines: 0,
        skip_rows: 0,
        has_multiple_sheets: false,
        skip_blanks: true,
        compression: null,
        compression_codec: null,
        line_terminator: "\n",
        has_comments: "false",
        comments_marker: "#",
        encoding: "utf-8",
        bad_lines: "skip",
      },
      filter_rules: [
        {
          name: "Total cost base filter",
          sql_query: "[$$column1$$] > $$var5$$",
          id: 0.8538673327511133,
        },
      ],
    },
  },
};

export const validationReRunMockData: any = {
  validation_request_body: {
    resource_data: {
      resource_id: 913,
      linked_service_id: 27,
      linked_service_code: "localFile1",
      connection_key: 28,
      resource_path: "E:\\Data_Files\\SampleFiles\\Research_query_files",
      file_name: "GWP_Position_202212124_Change_int.xlsx",
      column_delimiter: "|",
      resource_prefix: null,
      sql_query: null,
      container_name: null,
      file_pre_processing: {
        file_format: "xlsx",
        schema_definition: "string",
        field_delimiter: "|",
        custom_attributes: {
          type: "string",
          store_name: "string",
          store_label: "string",
        },
        has_footer: false,
        footer_lines: 0,
        has_header: true,
        header_lines: 0,
        skip_rows: 0,
        has_multiple_sheets: false,
        skip_blanks: true,
        compression: null,
        compression_codec: null,
        line_terminator: "\n",
        has_comments: "false",
        comments_marker: "#",
        encoding: "utf-8",
        bad_lines: "skip",
      },
    },
  },
};

export const reRunReqBody: any = {
  resource_data: [
    {
      aggregation_type: "flat",
      file_processing_code: null,
      domain_id: 5,
      additional_properties: {
        resource_definition: {
          type: "local",
          local_definition: {
            resource_path: "E:\\Data_Files\\SampleFiles\\Research_query_files",
            file_name: "GWP_Position_202212124_Change_int.xlsx",
            column_delimiter: "|",
            connection_key: 28,
            connection_key_code: "connection_key_28",
          },
          blob_definition: null,
          sql_definition: null,
          sftp_definition: null,
          api_definition: {
            request_timeout: 0,
          },
          resource_path: "E:\\Data_Files\\SampleFiles\\Research_query_files",
          file_name: "GWP_Position_202212124_Change_int.xlsx",
          column_delimiter: "|",
          connection_key: 28,
          connection_key_code: "connection_key_28",
        },
      },
    },
  ],
};

export const newResourceData: any = [
  {
    resource_name: "Fact",
    resource_path:
      "C:\\Users\\Akshaypratap\\Desktop\\VIS\\DATA\\FactSet_Position_202212124.xlsx",
    domain_id: 1,
    domain_resource_mapping: {
      columns: [
        {
          domain_column_name: "AccountCode",
          resource_column_name: "Portfolio Table",
        },
        {
          domain_column_name: "SecurityID",
          resource_column_name: "Fisher Sec ID",
        },
        {
          domain_column_name: "LongShortCode",
          resource_column_name: "L/S",
        },
        {
          domain_column_name: "Quantity",
          resource_column_name: "Quantity",
        },
        {
          domain_column_name: "MarketValueBase",
          resource_column_name: "MKT_VAL_SOD",
        },
      ],
    },
    resource_type: "Local",
    id: 1,
    resource_prefix: "fact",
  },
];

export const resourceCDMColumns = {
  id: 0,
  domain_column: "",
  column_name: "",
  datatype: "string",
  is_mandatory: false,
  data_format: "",
  key: false,
  is_active: true,
  severity_level: "Low",
  action: "",
  column_length: null,
  is_masking: false,
  is_reference: null,
  reference_column_definition: null,
  custom_validations: null,
  is_derived: null,
  reference: "",
  derived_column_definition: null,
};

export const defaultResourceCDMColumns = {
  id: 0,
  domain_column: "",
  column_name: "file_name",
  datatype: "string",
  is_mandatory: false,
  is_masking: false,
  data_format: "",
  key: false,
  is_active: true,
  action: "",
  column_length: null,
  severity_level: "Low",
  is_reference: null,
  reference_column_definition: null,
  custom_validations: null,
  is_derived: null,
  derived_column_definition: null,
};

export const defaultEditResourceCDMColumns = {
  id: 0,
  domain_column: "",
  column_name: "file_name",
  datatype: "string",
  is_mandatory: false,
  is_masking: false,
  data_format: "",
  key: false,
  is_active: true,
  action: "",
  column_length: "",
  severity_level: "Low",
  is_reference: null,
  reference_column_definition: null,
  custom_validations: null,
  is_derived: null,
  derived_column_definition: null,
};

export const editResourceCDMColumns = {
  id: 0,
  column_name: "",
  domain_column: "",
  datatype: "string",
  is_mandatory: false,
  is_masking: false,
  data_format: "",
  column_length: null,
  is_derived: null,
  derived_column_definition: null,
  is_reference: null,
  reference_column_definition: null,
  custom_validations: null,
  key: false,
  is_active: true,
  severity_level: "Low",
};

export const validationErrorsMockData = {
  items: [
    {
      id: 592,
      execution_id: 24782,
      resource_id: 132,
      snapshot_sequence_id: 1,
      column_name: "FishIndustry",
      resource_keys: {
        "Portfolio Code": 1,
        "Security Code": "SEC1",
      },
      custom_validation_name: "",
      error_message:
        " Length of FishIndustry column should be less than or equals to 10",
      file_name: "GWP_Position_202212124_Change_int.xlsx",
    },
  ],
  total: 70,
  page: 1,
  size: 25,
  pages: 3,
};

export const validationDuplicateErrorsMockData = {
  items: [
    {
      id: 30,
      execution_id: 24782,
      resource_id: 132,
      snapshot_sequence_id: 1,
      resource_keys: {
        "Portfolio Code": 11,
        "Security Code": "SEC11",
      },
      error_message: "Duplicate Record",
      file_name: "GWP_Position_202212124_Change_int.xlsx",
    },
  ],
  total: 3,
  page: 1,
  size: 25,
  pages: 1,
};

export const crossFieldValidationsMockData = {
  items: [
    {
      id: 154,
      execution_id: 24782,
      cross_field_validation_results: {
        name: "Cost Limit",
        result: {
          "Portfolio Code": 5,
          "Security Code": "SEC5",
          Quantity: 400,
          "Market Value Base": 7000,
          "Unit Cost Base": 100,
          "Total Cost Base": 7000,
          "Unrealized GainLoss": "20000",
          "Position Effective Date": null,
          "Accrued Interest Base": null,
          FishIndustry: null,
          FishSecID: null,
          FishValue: null,
          file_name: "GWP_Position_202212124_Change_int.xlsx",
          "Derived L/S": "S",
        },
        resource_id: 132,
      },
    },
  ],
  total: 9,
  page: 1,
  size: 25,
  pages: 1,
};

export const nullKeysValidationsMockData = {
  items: [
    {
      id: 221,
      execution_id: 24782,
      resource_id: 132,
      snapshot_sequence_id: 1,
      error_message: "Unique Keys are Null",
      file_name: "GWP_Position_202212124_Change_int.xlsx",
    },
  ],
  total: 20,
  page: 1,
  size: 25,
  pages: 1,
};
